module["exports"] = [
  "(####) ######",
  "##########",
  "06########",
  "06 #### ####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/phone_number/formats.js
// module id = 1702
// module chunks = 0